import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { useTranslation } from 'next-i18next';

import SplitLayout from 'src/components/other/SplitLayout';

import useAppRouter from 'src/hooks/useAppRouter';
import Icon from 'src/components/ui/Icon';
import ForgotPasswordForm from 'src/components/auth/ForgotPasswordForm';

import { colours } from 'src/constants/colours';
import { routePathLogin } from 'src/constants/router';
import { styledTag } from 'src/utils/styled';

const MobileLayout = styledTag('div')`
    background-color: ${colours.white.main};
    min-height: 100vh;
`;
const MobileLayoutInner = styledTag('div')`
    max-width: 36rem;
    margin: 0 auto;
`;

const CloseButtonContainer = styledTag('div')`
    width: 3rem;
    height: 3rem;
    background-color: ${colours.white.main};
    top: 1.75rem;
    right: 1.75rem;
    border-radius: 3rem;
    border: solid ${colours.lightGray} 0.0625rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const ForgotPasswordPage: PageComponent = () => {
    const router = useAppRouter();
    const { t } = useTranslation(['common']);
    const mobileView = Boolean(router.query.mobileView);

    // Used by mobile app
    // /forgot-password?mobileView=true
    if (mobileView) {
        return (
            <MobileLayout>
                <MobileLayoutInner>
                    <ForgotPasswordForm />
                </MobileLayoutInner>
            </MobileLayout>
        );
    }

    return (
        <SplitLayout
            panelTopLeft={
                <CloseButtonContainer>
                    <Icon name="Close" onClick={async () => router.push(routePathLogin)} />
                </CloseButtonContainer>
            }
            panelContent={<ForgotPasswordForm />}
        />
    );
};

export const getServerSideProps = async ({ locale }: { locale: string }) => ({
    props: {
        ...(await serverSideTranslations(locale, ['common'])),
        SEOProps: {
            pageTitleTranslation: {
                key: 'common:seo.forgotPassword',
            },
        },
    },
});

export default ForgotPasswordPage;
